import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  keywords?: string;
  noIndex?: boolean;
}

export function SEO({
  title = 'Leka - Master Languages with Smart Flashcards',
  description = 'Translate, save, and remember words with smart flashcards. Spaced repetition for Spanish, French, German & more. Free to start.',
  canonical = 'https://lekalearning.com',
  ogType = 'website',
  ogImage = 'https://lekalearning.com/og-image.png',
  keywords,
  noIndex = false,
}: SEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
    </Helmet>
  );
}
